var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.isSetStyle ? 'floating main' : 'floating',attrs:{"href":_vm.whatsappUrl,"target":"_blank","id":"floating-id"}},[_c('img',{attrs:{"loading":"lazy","width":"55","height":"55","src":require("@/assets/images/common/whatsapp.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }